/**
 * 사용자의 성인인증이 필요할 때 사용하는 레이어
 * 모바일웹일 때만 사용한다.
 * - PC: PHP 페이지 사용
 * - 앱: CallApp
 */
export default class AdultCertLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_adult_cert';
    this.render();
    this.setEvent();
  }

  open = () => {
    TMON.oApp.oUtil.handleOpenLayer({
      welTargetLayer: $(`#${this.sWrapper}`),
      bSetHash: false,
    });
  };

  render() {
    const sTitle = '성인인증';
    const sHtml = `
            <section class="popup popup_adult" style="display: flex;">
                <header class="popup_header">
                    <h3 class="popup_header_title">${sTitle}</h3>
                    <button type="button" class="popup_header_close" aria-label="팝업닫기" data-role="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                        </svg>
                    </button>
                </header>
                <div class="popup_contents">
                    <article class="popup_inner">
                        <i class="ico_19"></i>
                        <h5 class="title">본인인증이 필요한 상품입니다.<br>인증방법을 선택해주세요.</h5>
                        <p class="text">타인의 명의도용시 관련법규에<br>의거 처벌될 수 있습니다.</p>
                    </article>
                    <!-- [D] 버튼 -->
                    <div class="popup_buttons">
                            <button type="button" class="popup_button type01" data-role="adultcert" data-certtype="cellphone">
                            휴대폰 인증
                            </button>
                    </div>
                    <div class="description">
                        <p class="text">휴대폰 본인인증 진행과정에 문제가 있을 경우, 아래 고객센터로 문의해 주세요.</p>
                        <ul class="list">
                            <li>드림시큐리티 고객센터 1899-4134</li>
                        </ul>
                    </div>
                </div>
            </section>
        `;
    $('#_layerContainer').append(sHtml);
  }

  setEvent() {
    $('[data-role=adultcert]').on('click', e => {
      this.handleCertification($(e.currentTarget).attr('data-certtype'));
    });
  }

  clearEvent() {
    $('[data-role=adultcert]').off('click');
  }

  handleCertification = sWay => {
    const sCurrentUrl = encodeURIComponent(window.location.href);
    const sComQueryString = `token=${new Date().getTime()}&flag=adult`;
    const sType = sWay === 'cellphone' ? 'mycert' : 'ipin';

    if (TMON.view_mode === 'app') {
      // 앱일 때는 여기로 올 수가 없어야 한다. 만약 아래 alert 이 호출되면 성인인증 상황에서 정상적으로 콜앱을 날리고 있는지 확인할 것.
      alert(
        '죄송합니다. 일시적인 오류로 성인인증을 완료할 수 없습니다. PC버전이나 모바일웹 버전에서 성인인증을 완료하여 주십시오.'
      );
    } else {
      window.location.href = `${TMON.htLocal.htURL.adultCert}${sType}?view_mode=web&current_url=${sCurrentUrl}&cancel_url=&${sComQueryString}`;
    }
  };
}
